<template>
  <div>
    <h1>Actualizar geocerca</h1>
    <div class="card">
      <div class="card-body">
        <a-form :form="form" @submit.prevent="handleSubmit" layout="vertical">
          <div class="row">
            <div class="col-md-6">
              <label>Geocerca (adjuntar archivo .kmz)</label>
              <b-form-file
                v-model="$v.geofence.file.$model"
                ref="file"
                :state="fileState"
                :placeholder="kmzFile"
                browse-text="Geocerca"
                drop-placeholder="Drop file here..."
                @change="onFileSelected"
                accept=".KMZ"
                ></b-form-file>
            </div>
            <div class="col-md-6">
              <a-form-item label="Nombre de la geocerca">
                <a-input ref="name" placeholder="Nombre de la geocerca" v-model="$v.geofence.name.$model" />
                <small class="text-danger" v-if="!$v.geofence.name.required">Campo requerido. No debe estar vacío.</small><br>
                <small class="text-danger" v-if="!validateRegisteredGeofence($v.geofence.name.$model)">Ya existe un registro con este nombre</small>
              </a-form-item>
            </div>
            <div class="col-12">
              <a-form-item>
                <button ref="button" type="submit" class="btn btn-light px-5" :disabled="!(validateRegisteredGeofence($v.geofence.name.$model) && !$v.$invalid)">
                  Actualizar
                </button>
              </a-form-item>
            </div>
          </div>
        </a-form>
      </div>
    </div>
  </div>
</template>
<script>
import { required } from 'vuelidate/lib/validators'
import { uploadFileS3 } from '../../../s3/s3Up.js'
import gql from 'graphql-tag'
import headers from '@/config/headers.js'
const UPDATE_GEOFENCE = gql`
  mutation updateGeofence($geofenceId: Int, $kmzFile: String, $name: String){
    updateGeofence(geofenceId: $geofenceId geofenceRequest: { kmzFile: $kmzFile name: $name }){
      kmzFile
      name
    }
  }
`
const GET_ALL_GEOFENCES = gql`
  query getAllGeofences{
    getAllGeofences{
      id
      name
    }
  }
`
export default {
  data() {
    return {
      form: this.$form.createForm(this),
      geofence: {
        file: new File([''], this.$route.params.kmzFile.split('/').pop()),
        name: this.$route.params.name,
      },
      kmzFile: this.$route.params.kmzFile.split('/').pop(),
      fileState: null,
      createdBy: this.$store.state.user.email,
      registeredGeofences: {},
    }
  },
  apollo: {
    getAllGeofences: {
      query: GET_ALL_GEOFENCES,
      context: headers(),
      result({ data }) {
        data.getAllGeofences.forEach(geofence => {
          this.registeredGeofences[geofence.name] = 1
        })
        delete this.registeredGeofences[this.geofence.name]
      },
    },
  },
  created() {
    // console.log(this.$route.params)
  },
  methods: {
    async handleSubmit() {
      let location = ''
      if (this.kmzFile === this.geofence.file.name) {
        location = this.$route.params.kmzFile
      } else {
        const file = []
        file.fileExtension = this.geofence.file.name.split('.').pop()
        file.fileUploaded = this.geofence.file
        const uploadedFile = await uploadFileS3(file)
        location = uploadedFile.Key
      }
      this.$apollo.mutate({
        mutation: UPDATE_GEOFENCE,
        context: headers(),
        variables: {
          geofenceId: parseInt(this.$route.params.id),
          kmzFile: location,
          name: this.geofence.name,
        },
      })
        .then(data => {
          this.$router.push({ name: 'GetGeofences' })
        })
        .catch(error => {
          console.log(error)
        })
      // console.log(this.geofence.file)
    },
    validateRegisteredGeofence(name) {
      if (this.registeredGeofences[name.trim()]) {
        return false
      } else {
        return true
      }
    },
    onFileSelected(event) {
      this.geofence.file = event.target.files[0]
      // console.log(event.target.files[0])
      // console.log(this.geofence.file)
    },
  },
  validations: {
    geofence: {
      file: { required },
      name: { required },
    },
  },
}
</script>
